<div class="container">
    <div class="row g-0 mt-5">
        <div class="col-11 col-md-10 col-lg-9 d-flex">
            <div class="alert text-white" style="background-color: rgba(0, 0, 0, 0.8);">
                <a (click)="showModalFaq()" nz-tooltip nzTooltipTitle="Preguntas frecuentes"
                    nzTooltipPlacement="topLeft">
                    <span class="material-symbols-outlined align-middle">
                        help
                    </span>
                </a>
                <span class="mx-2"></span>
                <a nz-tooltip nzTooltipTitle="Contacto" nzTooltipPlacement="top" class="text-white text-decoration-none"
                    nz-dropdown [nzDropdownMenu]="menu" nzTrigger="click" nzPlacement="topLeft">
                    <span class="material-symbols-outlined align-middle">
                        contact_emergency
                    </span>
                </a>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                    <ul nz-menu>
                        <ng-container *ngFor="let item of configInitial.contacto">
                            <li *ngIf="item.type === 'phone'" nz-menu-item>
                                <button type="button" (click)="goToCall(item.value)" class="w-100 border-0 bg-transparent text-start p-0">
                                    <i class="fas fa-phone me-2"></i>{{ item.label }}
                                </button>
                            </li>
                            <li *ngIf="item.type === 'email'" nz-menu-item>
                                <button type="button" (click)="goToMail(item.value)" class="w-100 border-0 bg-transparent text-start p-0">
                                    <i class="fas fa-paper-plane me-2"></i>{{ item.label }}
                                </button>
                            </li>
                            <li *ngIf="item.type === 'whatsapp'" nz-menu-item>
                                <button type="button" (click)="goToWAPP(item.value)" class="w-100 border-0 bg-transparent text-start p-0">
                                    <i class="fab fa-whatsapp me-2"></i>{{ item.label }}
                                </button>
                            </li>
                        </ng-container>
                    </ul>
                </nz-dropdown-menu>
                <span class="mx-2">|</span>
                <a class="text-white text-decoration-none" rel="noopener" [href]="configInitial.aviso_privacidad"
                    target="_blank">Aviso de
                    Privacidad</a>
            </div>
        </div>
    </div>
</div>

<nz-modal [(nzVisible)]="isVisibleModalFaq" [nzCancelDisabled]="true" [nzWidth]="800" nzTitle="Preguntas frecuentes"
    (nzOnOk)="handleCancelModalFaq()" [nzClosable]="false">
    <ng-container *nzModalContent>
        @for (questionSection of configInitial.faq_section; track $index) {
            <div class="row {{ $index === 0 ? '' : 'mt-3' }}">
                <div class="col-12">
                    <h6>{{ questionSection.title_section }}</h6>
                </div>
                <div class="col-12">
                    <nz-collapse nzAccordion>
                        @for (question of questionSection.questions; track $index) {
                            <nz-collapse-panel [nzHeader]="question.question"
                                [nzActive]="false">
                                <div class="" [innerHTML]="question.response"></div>
                            </nz-collapse-panel>
                        }
                        
                    </nz-collapse>
                </div>
            </div>
        }@empty {
            <p>Aún no se añaden preguntas frecuentes.</p>
        }
    </ng-container>
</nz-modal>